import React, { useEffect, useRef, useState } from 'react';
import { getMarketingConsentChoice, metaTrack, storeMarketingConsent } from '../analytics/metaPixel';

export const MarketingConsent = () => {
  const [choice, setChoice] = useState(() => getMarketingConsentChoice());
  const initialPageViewSent = useRef(false);

  useEffect(() => {
    if (choice !== 'granted' || initialPageViewSent.current) return;
    initialPageViewSent.current = true;
    metaTrack('PageView');
  }, [choice]);

  if (choice) return null;
  const choose = (granted) => {
    storeMarketingConsent(granted);
    setChoice(granted ? 'granted' : 'denied');
  };

  return (
    <aside className="marketing-consent" data-testid="marketing-consent-banner" aria-label="Préférences de suivi">
      <p>Nous utilisons des cookies marketing pour mesurer l’audience et améliorer la boutique.</p>
      <div className="marketing-consent-actions">
        <button type="button" onClick={() => choose(false)} data-testid="marketing-consent-refuse">Refuser</button>
        <button type="button" onClick={() => choose(true)} data-testid="marketing-consent-accept">Accepter</button>
      </div>
    </aside>
  );
};